var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2266 16.3854V17.8521C25.2266 19.9056 25.2266 20.9324 24.7906 21.7167C24.4071 22.4066 23.7952 22.9676 23.0425 23.3191C22.1869 23.7187 21.0668 23.7187 18.8266 23.7187H7.62656C5.38635 23.7187 4.26625 23.7187 3.4106 23.3191C2.65795 22.9676 2.04603 22.4066 1.66254 21.7167C1.22656 20.9324 1.22656 19.9056 1.22656 17.8521V16.3854M19.8932 7.82986L13.2266 1.71875M13.2266 1.71875L6.5599 7.82986M13.2266 1.71875V16.3854",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0d8d164344f91ebe9281f914bd100c2b.svg";
export { ForwardRef as ReactComponent };